import { render, staticRenderFns } from "./AdditionalFilesTable.vue?vue&type=template&id=656359b0&"
import script from "./AdditionalFilesTable.vue?vue&type=script&lang=js&"
export * from "./AdditionalFilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports